export default {
  logout: 'Logout',
  signin: 'Sign In',
  user: 'Login',
  password: 'Password',
  validations: {
    inputUser: 'Please, input user name',
    inputPassword: 'Please, input password',
    required: 'Field is required'
  },
  errors: {
    isLocked: 'The User is blocked',
    wrongLogin: 'Wrong login or password',
    unknownError: 'Unknown error',
    serverError: '500 Internal Server Error',
    readBriefingsDenied: 'The user does not have permission to view briefings',
    'no-server-connection': 'No server connection'
  },
  success: {
    title: 'Success',
    message: 'Updates received',
    copied: 'Copied'
  },
  info: {
    'downloaded-to-device': 'Downloaded to device',
    noUpdates: 'No updates',
    'latest-update': 'Latest update: {time}',
    'action-required': 'Action required'
  },
  navbar: {
    search: 'Search…',
    dateStart: 'From',
    dateEnd: 'To',
    profile: 'Profile'
  },
  notification: {
    success: 'Success',
    error: 'Error',
    errors: 'Errors:',
    warning: 'Warning',
    info: 'Information'
  },
  'no-briefings': 'No briefings for the specified period!',
  default: 'Default',
  download: 'Download',
  notes: 'Notes',
  'add-note': 'Add note',
  'add-file': 'Upload',
  delete: 'Delete',
  cancel: 'Cancel',
  reload: 'Reload',
  'confirm-deletion': 'Confirm the file deletion',
  apply: 'Apply',
  approve: 'Approve',
  save: 'Save',
  reset: 'Reset',
  yes: 'Yes',
  confirmation: 'Action confirmation',
  'download-version': 'Download version',
  'download-confirmed': 'Download verified',
  'download-draft': 'Download draft',
  'download-signed': 'Download signed',
  'send-briefing': 'Send a briefing',
  'send-confirmed': 'Send confirmed',
  'send-draft': 'Send draft',
  'num-of-emails-sent': 'Successfully sent:',
  settings: 'Settings',
  'input-email': 'Enter Email',
  'your-comment': 'Your comment',
  'add-comment': 'Add a comment…',
  'additional-info': 'Additional info',
  'send-email': {
    'add-additional-recipients': 'Add additional addresses',
    'additional-recipients': 'Additional recipients',
    'invalid-address': 'Check the recipient list. Invalid addresses:',
    sending: 'Sending…'
  },
  file: {
    'download-upload-documents': 'Download/upload documents',
    upload: 'Upload',
    download: 'Download',
    'upload-to-server': 'Upload to server',
    'open-pdf': 'Open PDF',
    auto: 'Auto',
    manual: 'Manual',
    total: 'Total',
    nofiles: 'No files',
    'generate-pdf': 'Generate pdf',
    'valid-until': 'Valid until: {date}',
    size: 'Size',
    bytes: 'B',
    kb: 'KB',
    mb: 'MB',
    invalidFileFormat: 'Invalid file format',
    acceptableFormats: 'Acceptable formats'
  },
  'desks-filter': {
    desk: 'Desk',
    'check-all': 'Check all'
  },
  'fleet-filter': {
    'flight-code': 'Flight code',
    'vehicle-type': 'Vehicle type',
    helicopters: 'Helicopters',
    planes: 'Planes'
  },
  'user-data': {
    title: 'Personal info',
    name: 'Name',
    phone: 'Phone number',
    email: 'Email'
  },
  pages: {
    error404: '404',
    profile: 'Profile',
    briefings: 'Briefings',
    login: 'Login'
  },
  typeOfCrew: 'Type of crew',
  'select-locale': 'Select language',
  'build-info': 'Version: { version } Build date: { buildDate }',
  'table-headers': {
    version: 'Version',
    status: 'Status',
    flight: 'Flight',
    briefing: 'Briefing',
    pic: 'PIC',
    duty: 'Duty',
    number: '#'
  },
  'date-filter': {
    from: 'from',
    to: 'to',
    h: 'h'
  },
  userSettings: {
    shiftTimeStart: 'Start of time shift',
    shiftTimeEnd: 'End of time shift',
    settingsReset: 'Settings reset',
    settingsSaved: 'Settings have been saved',
    'undo-changes': 'Undo changes',
    compactTable: 'Compact table view',
    viewsFiles: 'Views files',
    displayedPortCode: 'Displayed port code',
    showFormattedPhones: 'Show formatted phone numbers',
    'enable-dark-theme': 'Enable dark theme',
    'show-desk': 'Show flight group'
  },
  'email-not-listed': 'Email not listed',
  'phone-not-listed': 'Phone not listed',
  'aircraft-crew': 'Crew',
  history: 'History of changes',
  'update-time': 'Update time',
  updated: 'Updated',
  before: 'Before',
  after: 'After',
  'mark-as-read': 'Mark as read',
  restoreDefaultValues: 'Restore default values',
  enableCompactMode: 'Enable compact mode',
  setNumOfCopies: 'Configure the number of copies',
  noFilesInSection: 'There are no files in this section',
  'not-available': 'N/A',
  'download-date': 'Download date',
  'date-of-signing': 'Date of signing',
  'rejection-date': 'Rejection date',
  'date-of-change': 'Date of change',
  'change-section': {
    'apply-changes': 'Apply the changes',
    'ignore-changes': 'Ignore the changes',
    updating: 'Updating section…'
  },
  common: {
    'compiled-version': 'Compiled version',
    'creation-date': 'Creation date',
    'refresh-data': 'Refresh data',
    commentary: 'Commentary',
    copy: 'Copy',
    date: 'Date',
    downloading: 'Downloading file…',
    loading: 'Loading…',
    system: 'System',
    all: '--all--'
  },
  filename: {
    'file-deleted': 'File deleted',
    'file-is-missing': 'File is missing'
  },
  cfp: {
    channel: {
      external: 'auto',
      fromArinc: 'from ARINC',
      fromPdf: 'from PDF',
      fromTxt: 'from TXT',
      manual: 'manual'
    },
    'create-from-arinc': 'Create from ARINC',
    'create-from-pdf': 'Create from PDF',
    'create-from-txt': 'Create from TXT',
    'file-will-be-replaced': 'The file will be replaced',
    'files-can-be-replaced': 'Files can be replaced',
    'open-original': 'Open the original',
    'source-file-is-missing': 'The source file is missing',
    'upload-manually': 'Upload manually',
    replace: 'Replace'
  },
  'briefing-history': {
    title: 'History of Briefing Changes',
    'current-version': 'Current version',
    'only-approved': 'Only approved'
  },
  'cell-briefing': {
    'approve-briefing': 'Approve the briefing',
    'cancel-briefing': 'Cancel briefing',
    'date-of-confirmation': 'Date of confirmation',
    'download-archive': 'Download archive',
    'download-briefing': 'Download briefing',
    'files-missing': 'There are no files in sections',
    'private-comment': 'Private comment',
    'send-email': 'Send by email',
    comment: 'Comment',
    dispatcher: 'Dispatcher'
  },
  'pic-actions': {
    acceptance: 'Acceptance',
    action: 'Действие',
    correction: 'Correction',
    download: 'Download',
    history: 'History of actions',
    rejection: 'Rejection',
    navlog: 'Navlog saved',
    details: 'Details',
    fuel: 'Fuel',
    comment: 'Comment',
    'not-processed': 'Not processed',
    processed: 'Processed',
    'processed-date': 'Processing date',
    'processing-attempt': 'Attempt',
    'processed-error': 'Processing error',
    'outdated-version': 'Outdated version',
    'export-result': 'Export { attempt }',
  }
}
